<template>
  <gj-modal
      size="1200_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
  >
    <template #header>
      预算分析-{{row.campaignName}}
    </template>
    <template #content>
      <div class="flex justify-between">
        <div class="flex align-center">
          <gj-radio-group
              v-model="type"
              :options="[
                {id:'summary',text:'汇总'},
                {id:'detail',text:'明细'},
              ]"
          >
          </gj-radio-group>
          <gj-date-picker
              v-model="date"
              type="daterange"
              :clearable="false"
              tooltip="数据时间"
              :max-day-length="31"
              :shortcuts="['今天', '昨天', '近7天', '近14天', '近30天', '本月', '上月']"
              @change="$gjNoticeQuery"
              style="margin: 0 12px"
          ></gj-date-picker>
<!--          <gj-help style="font-size: 16px;">广告活动状态每半小时从亚马逊同步一次，因此系统中统计的超预算时间和实际的广告活动超预算时间最多有30分钟的差距。</gj-help>-->
        </div>
        <div>
          <gj-tool-group
              download
              download-url="/ads/sp/campaigns/outOfBudgetAnalysisExport"
              :download-params="params"
          ></gj-tool-group>
        </div>
      </div>

      <div style="height: 450px;margin-top: 12px;" v-show="type==='summary'">
        <gj-table
            ref="gjTable"
            adaptParent
            :index="false"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            :scroll-x="{gt: -1}"
            :scroll-y="{gt: -1}"
            border="full"
            @page-change="$gjNoticeQuery"
        >

          <template v-slot:logList="{row}">
            <div class="time-block" v-if="row.logList">
              <div class="time-block-bg">
                <div v-for="(item,index) in row.logList.filter(r=> r.width)" :key="index" class="time-block-item" :style="{'left': item.left+'%', 'width': item.width+'%'}">
                  <gj-popover-panel
                      :open-delay="0"
                      :close-delay="0"
                      trigger="hover"
                      placement="bottom"
                      :width="'300px'"
                      :hasIcon="false"
                      :data="buildDetail(item)"
                      style="width: 100%;height: 100%;display: inline-block;"
                  >
                  </gj-popover-panel>
                </div>
              </div>
              <div class="flex justify-between">
                <div v-for="i in 25" :key="i" class="time-block-scale" :class="{'time-block-scale-long':[1,7,13,19,25].includes(i)}"></div>
              </div>
              <div class="flex" style="position: relative;height: 12px;">
                <div class="time-block-str color999" style="left:  calc(0% - 14px)">0点</div>
                <div class="time-block-str color999" style="left:  calc(25% - 14px)">6</div>
                <div class="time-block-str color999" style="left: calc(50% - 14px)">12</div>
                <div class="time-block-str color999" style="left: calc(75% - 14px)">18</div>
                <div class="time-block-str color999" style="left: calc(100% - 14px)">24点</div>
              </div>
            </div>


          </template>
        </gj-table>
      </div>

      <div style="height: 450px;margin-top: 12px;" v-show="type==='detail'">
        <gj-table
            ref="gjTable1"
            adaptParent
            :index="false"
            :loading="loading"
            :data="tableData1"
            :columns="columns1"
            :scroll-x="{gt: -1}"
            :scroll-y="{gt: -1}"
            border="full"
            :structure-config="{type: 'ParentChild', children: 'logList', spanType: 'row', parentSpan: [0]}"
            @page-change="$gjNoticeQuery"
        >

          <template v-slot:header:budgetInterval>
            预算时段
            <gj-help>
              根据当日广告活动预算的调整记录（N次）划分的时段，将24小时划分为N+1个时段<br>
              1.预算调整记录：包含系统内和系统外（亚马逊或第三方工具）的调整，在系统外调整，因同步频次原因，预算时段有至多15分钟的误差<br>
              2.示例：当天“12:00”、“18:40”调整过预算，则预算时段为“00:00-12:00”、“12:00-18:40”、“18:40-24:00”三个时段
            </gj-help>
          </template>

          <template v-slot:header:exposureTimeInterval>
            估算曝光时段
            <gj-help>
              通过预算时段和超出预算状态综合评估得出<br>
              1. 若预算时段内有超出预算，则曝光时段为预算起始时间到超出预算时间<br>
              2. 若预算时段内及之前的时段无超出预算情况，则曝光时段等于预算时段<br>
              3. 若当日有时段已超预算，且后续时段未增加预算，则后续时段显示无曝光

            </gj-help>
          </template>



        </gj-table>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, queryMixin} from "@/minxins";
import {subDays} from "date-fns";
import {SP} from "@/api/ad";
import {convertToDate} from "@/utils/date.util";
export default {
  name: "out-of-budget-modal",
  mixins:[modalMixIn, queryMixin],
  props:{
    row:{
      type:Object,
      require:true,
      default:()=>{}
    }
  },
  data(){
    return {
      loading:false,

      type:'summary',

      date:[subDays(new Date(), 6), new Date()],

      dayMinutes: 24*60,

      tableData:[],
      columns:[
        {id: 'date', header: '日期', field: 'date', width: '140px'},
        {id: 'budget', header: '每日预算', field: 'budget', width: '160px',prefix: 'currencySymbol', help:'取当天你为广告活动设置过的最高预算'},
        {id: 'cost', header: '花费', field: 'cost', width: '160px',  prefix: 'currencySymbol',},
        {id: 'impressions', header: '曝光量', field: 'impressions', width: '160px',  help:''},
        {id: 'exposureTime', header: '估算曝光时长', field: 'exposureTime', width: '150px', help:'当日多个预算时段的估算曝光时长和'},
        {id: 'logList', header: '曝光时长分布', field: 'slot:logList', minWidth: '100px', help:'当日估算曝光时段的分布情况'},
      ],
      tableData1:[],
      columns1:[
        {id: 'budgetDate', header: '日期', field: 'budgetDate', width: '120px'},
        {id: 'budgetInterval', header: 'slot:budgetInterval', field: 'budgetInterval', width: '120px'},
        {id: 'budget', header: '预算', field: 'budget', width: '100px', prefix: 'currencySymbol', help:'时段内您为广告活动设置的预算'},
        {id: 'estimateCost', header: '估算花费', field: 'estimateCost', width: '100px', prefix: 'currencySymbol', help:'当日0点到预算时段截止时间的花费，由于亚马逊当日数据有延时，花费仅供参考'},
        {id: 'impressions', header: '估算曝光量', field: 'impressions', width: '100px',  help:'当日0点到预算时段截止时间的曝光量，由于亚马逊当日数据有延时，曝光量仅供参考'},
        {id: 'outOfBudgetTime', header: '超出预算时间', field: 'outOfBudgetTime', minWidth: '120px', help:'ERP同步到广告活动状态为“超出预算”时的站点时间，因同步频次原因，超出预算时间至多有15分钟误差'},
        {id: 'exposureTimeInterval', header: 'slot:exposureTimeInterval', field: 'exposureTimeInterval', minWidth: '160px'},
        {id: 'exposureTime', header: '估算曝光时长', field: 'exposureTime', minWidth: '160px', help:'预算时段内估算的广告实际曝光时间，估算曝光时段截止时间和起始时间的时间差'},
        {id: 'notExposureTime', header: '估算未曝光时长', field: 'notExposureTime', minWidth: '160px',help: '预算时段内估算的广告未曝光时间，预算时段截止时间和估算曝光时段截止时间的时间差'},
      ],
    }
  },
  computed:{
    params(){
      return {
        marketId:this.row.marketId,
        startDate:convertToDate(this.date[0]),
        endDate:convertToDate(this.date[1]),
        campaignId:this.row.campaignId,
      }
    }
  },
  methods:{
    buildDetail(logList){
      return [
        [
          {label: '预算时段', value: logList.budgetInterval},
          {label: '估算曝光时段', value: logList.exposureTimeInterval},
          {label: '估算曝光时长', value: logList.exposureTime},
          {label: '估算未曝光时长', value: logList.notExposureTime}
        ]
      ]
    },
    $gjQuery(){
      this.loading = true;
      // let param = {
      //   marketId:this.row.marketId,
      //   startDate:convertToDate(this.date[0]),
      //   endDate:convertToDate(this.date[1]),
      //   campaignId:this.row.campaignId,
      // }
      // 汇总
      SP.outOfBudgetSummaryAnalysis(this.params).then(res => {
        this.tableData = res.data;
        this.tableData.forEach(row=>{
          row.logList.forEach(item=>{
            let value = item.exposureTimeInterval.split('-');
            if (value[0] !== value[1]) {
              let start = value[0].split(':');
              let end = value[1].split(':');
              let left = (start[0] * 60 + (start[1] - 0)) / this.dayMinutes * 100;
              let width = ((end[0] * 60 + (end[1] - 0)) - (start[0] * 60 + (start[1] - 0))) / this.dayMinutes * 100;
              item.left = left;
              item.width = width;
            }
          })
        })
      }).complete(()=>{this.loading = false;});
      // 明细
      SP.outOfBudgetDetailAnalysis(this.params).then(res => {
        this.tableData1 = res.data;
      }).complete(()=>{this.loading = false;});

    }
  }
}
</script>

<style scoped lang="scss">
/deep/.vxe-header--column {
  background: #f6f8fb !important;
}
/deep/.vxe-table--border-line{
  border: 1px solid #d8dadd !important;
}

.time-block{
  padding: 0 12px;
  .time-block-bg{
    height: 12px;
    background-color: #E0E1E4;
    position: relative;
  }
  .time-block-item{
    height: 100%;
    position: absolute;
    background-color: #4C8BF2;
  }
  .time-block-item:hover{
    //transform: scale(1.2);
    background-color: #73B2FF;
  }
  //.time-block-item+.time-block-item{
  //  border-left: 1px solid #E0E1E4;
  //}
  .time-block-scale{
    width: 1px;
    height: 4px;
    background-color: rgba(31,110,239,0.2);
  }
  .time-block-scale-long{
    height: 6px;
    background-color: #1F6EEF;
  }
  .time-block-str{
    position: absolute;
    line-height: 12px;
    font-size: 12px;
    width: 28px;
    text-align: center;
  }
}
/deep/.el-popover__reference-wrapper{
  width: 100%;height: 100%;display: inline-block;
  .el-popover__reference{
    width: 100%;height: 100%;display: inline-block;
  }
}
</style>